import React, { useState } from "react";
import RegistrationStepOne from "./RegistrationStepOne";
import RegistrationStepTwo from "./RegistrationStepTwo";
import RegistrationStepThree from "./RegistrationStepThree";
import RegistrationStepFour from "./RegistrationStepFour";
import RegistrationComplete from "./RegistrationComplete";
import axios from "../../axios";
import { toast } from "react-toastify";

export default function RegistrationFormContent() {
  const authToken = localStorage.getItem("access_token");
  const [formData, setFormData] = useState({
    guardianPhone1: "",
    guardianPhone2: "",
    guardianAddress1: "",
    guardianAddress2: "",
    guardianCity: "",
    guardianPostcode: "",
    emergencyFirstName: "",
    emergencyLastName: "",
    emergencyPhone: "",
    emergencyRelation: "",
    emergencyAddress1: "",
    emergencyAddress2: "",
    emergencyCity: "",
    emergencyPostcode: "",
    doctorName: "",
    doctorAddress1: "",
    doctorAddress2: "",
    doctorCity: "",
    doctorPostcode: "",
    doctorPhone: "",
    otherPromotionals: "",
    otherPrecautions: "",
    otherInternetAccess: "",
    otherLeadSource: "",
    otherVolunteer: "",
    otherEthnicity: "",
  });
  const [step, setStep] = useState(1);

  const incrementStep = (stepData) => {
    let newData = { ...formData, ...stepData };
    setFormData(newData);
    if (step < 4) {
      setStep(step + 1);
    } else {
      axios
        .post("/guardians", newData, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            setStep(step + 1);
          } else {
            toast.success("No response from server");
          }
        })
        .catch((error) => {
          toast.error("Something went wrong");
          console.log(error);
        });
    }
  };
  const decrementStep = (stepData) => {
    let newData = { ...formData, ...stepData };
    setFormData(newData);
    setStep(step - 1);
  };

  const steps = [
    <RegistrationStepOne data={formData} incrementStep={incrementStep} />,
    <RegistrationStepTwo
      data={formData}
      incrementStep={incrementStep}
      decrementStep={decrementStep}
    />,
    <RegistrationStepThree
      data={formData}
      incrementStep={incrementStep}
      decrementStep={decrementStep}
    />,
    <RegistrationStepFour
      data={formData}
      incrementStep={incrementStep}
      decrementStep={decrementStep}
    />,
    <RegistrationComplete step={step} setStep={setStep} />,
  ];

  return (
    <div className="row g-0 min-vh-100 align-items-center pt-4 pb-4">
      <div className="col-md-12 px-md-0 px-4">
        <div className="registration-form-content">
          {step >= 1 && step <= 4 ? (
            <div className="steps-progress mb-3 d-flex justify-content-center">
              <span className={step >= 1 ? "active" : undefined}>1</span>
              <hr />
              <span className={step >= 2 ? "active" : undefined}>2</span>
              <hr />
              <span className={step >= 3 ? "active" : undefined}>3</span>
              <hr />
              <span className={step >= 4 ? "active" : undefined}>4</span>
            </div>
          ) : null}
          <div className="steps-content mb-2 px-md-3 px-1 custom-scrollbar">
            {steps[step - 1]}
          </div>
        </div>
      </div>
    </div>
  );
}
